import classNames from 'classnames';
import * as React from 'react';

import { Bem } from '../../service/Bem/Bem';
import { formatName, Section } from '../../service/Experiments/Experiments';
import { CheckboxDecorator } from '../CheckboxDecorator/CheckboxDecorator';
import { HoverTooltipWrapper } from '../HoverTooltipWrapper/HoverTooltipWrapper';
import { MarkedText } from '../MarkedText/MarkedText';

import './Experiment.css';

interface ExperimentProps {
    data: Section;
    search: string;
    checked: boolean;
    disabled: boolean;
    onChecked: (
        e: React.KeyboardEvent<HTMLElement>,
        data: { item: Section; checked: boolean }
    ) => void;
    tooltip?: string;
    view?: 'classic' | 'default';
}

export class Experiment extends React.Component<ExperimentProps> {
    static getTooltipContent(text: string, content: React.ReactNode) {
        const span = (
            <span className={Bem.cls('experiment', 'popup')}>{text}</span>
        );
        return (
            <HoverTooltipWrapper
                to={['right', 'bottom']}
                tooltipText={span}
                isDoccenterTooltip={false}
                theme={'normal'}
                zIndexGroupLevel={8}
            >
                {content}
            </HoverTooltipWrapper>
        );
    }

    constructor(props: ExperimentProps) {
        super(props);

        this.state = {
            isTooltipVisible: false
        };
    }

    render() {
        const { data, tooltip } = this.props;

        const content = this.getContent();

        return (
            <div
                className={classNames(
                    Bem.cls('experiment'),
                    Bem.cls('experiment', '', {
                        archive: Boolean(data.archive)
                    })
                )}
                onMouseEnter={this.onMouseEnterHandler}
                onMouseLeave={this.onMouseLeaveHandler}
                style={{
                    display: 'inline-block'
                }}
            >
                {tooltip && tooltip.length
                    ? Experiment.getTooltipContent(tooltip, content)
                    : content}
            </div>
        );
    }

    private getContent = (): React.ReactNode => {
        const { data, view, disabled, checked, search, onChecked } = this.props;

        return (
            <CheckboxDecorator
                size="s"
                view={view}
                theme="normal"
                tone="grey"
                item={data}
                disabled={disabled}
                checked={checked}
                onChecked={onChecked}
            >
                <MarkedText
                    text={formatName(data.section_name, !!data.archive)}
                    search={search}
                />
            </CheckboxDecorator>
        );
    };

    private onMouseEnterHandler = () => {
        const { tooltip } = this.props;
        if (tooltip && tooltip.length) {
            this.setState({
                isTooltipVisible: true
            });
        }
    };

    private onMouseLeaveHandler = () => {
        this.setState({
            isTooltipVisible: false
        });
    };
}
